module.exports = __webpack_public_path__ + "images/img-12.861b83a4.jpg";